import React, { useEffect, useRef, useState } from "react";

import { CircularIndeterminate, FormButton } from "components";
import { FormikSelectInput, FormikTextInput, FormikYesOrNoInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as Yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    modalData,
    rowSelected,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";
import { ACTIONS } from "consts/Actions";

import { RequestServiceActions } from "services/services-mia/RequestServiceActions";

import styles from "styles/pages/ModalActions.module.scss";
import { Box, Paper } from "@mui/material";

import { useMIAService } from "hooks/useMIAService";
import { SBMTipoDeDocumentoGet } from "services/services-mia";

const prioridadList = [
    {
        label: "Indistinto",
        value: "N"
    },
    {
        label: "Primero internos",
        value: "I"
    },
    {
        label: "Primero externo",
        value: "E"
    }
]

export default function UpdateModal({ handleUpdateTable }) {
    const [inRequest, setInRequest] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingInfo, setIsLoadingInfo] = useState(true);
    const [disabledGroup, setDisabledGroup] = useState(false)
    const [tieneDocs, setTieneDocs] = useState(false)
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const setModalDetails = useSetRecoilState(modalData);
    const getSBMTipoDeDocumento = useMIAService(SBMTipoDeDocumentoGet);

    const row = useRecoilValue(rowSelected);
    const credentials = useRecoilValue(userCredentials);
    const formikRef = useRef(null)

    const handleGetData = async () => {
        const result = await getSBMTipoDeDocumento({ tipoDeDocumentoId: row.row.id });

        if (result[0]) {
            setTieneDocs(result[0].sbmTipoDeDocumentoTieneDocumentos === "Y")
            setDisabledGroup(!(result[0].sbmTipoDeDocumentoAgrupa === "Y"))
            formikRef.current.setValues({
                id: result[0].sbmTipoDeDocumentoId,
                tipoDeDocumentoCod: result[0].sbmTipoDeDocumentoCod,
                tipoDeDocumentoNombre: result[0].sbmTipoDeDocumentoNombre,
                tipoDeDocumentoDescripcion: result[0].sbmTipoDeDocumentoDescripcion,
                enviaMail: result[0].sbmTipoDeDocumentoMailer === "Y" ? true : false,
                agrupa: result[0].sbmTipoDeDocumentoAgrupa === "Y" ? true : false,
                agrupaCant: result[0].sbmTipoDeDocumentoAgrupaCantidad,
                prioridadFirma: result[0].sbmTipoDeDocumentoPrioridadIntExt,
                PHFirmante: result[0].sbmTipoDeDocumentoPHFirmantes === "Y" ? true : false,
                PHTickets: result[0].sbmTipoDeDocumentoPHTickets === "Y" ? true : false,
                version: result[0].sbmTipoDeDocumentoVersion
            })
        }
        setIsLoadingInfo(false)
    }

    const handleSubmit = async ({
        id,
        tipoDeDocumentoNombre,
        tipoDeDocumentoDescripcion,
        tipoDeDocumentoCod,
        enviaMail,
        agrupa,
        agrupaCant,
        prioridadFirma,
        PHFirmante,
        PHTickets,
        version
    }) => {
        setInRequest((inRequest) => !inRequest);
        setIsLoading((isLoading) => !isLoading);

        const body = {
            service: "SBMTipoDeDocumentoUpd",
            params: {
                sbmTipoDeDocumentoId: id,
                sbmTipoDeDocumentoCod: tipoDeDocumentoCod || null,
                sbmTipoDeDocumentoNombre: tipoDeDocumentoNombre,
                sbmTipoDeDocumentoDescripcion: tipoDeDocumentoDescripcion,
                sbmTipoDeDocumentoMailer: enviaMail === true ? "Y" : "N",
                sbmTipoDeDocumentoAgrupa: agrupa === true ? "Y" : "N",
                sbmTipoDeDocumentoAgrupaCantidad: Number(agrupaCant),
                sbmTipoDeDocumentoPrioridadIntExt: prioridadFirma,
                sbmTipoDeDocumentoPHFirmantes: PHFirmante === true ? "Y" : "N",
                sbmTipoDeDocumentoPHTickets: PHTickets === true ? "Y" : "N",
                sbmTipoDeDocumentoVersion: version
            },
        };

        let res = await RequestServiceActions(
            body,
            credentials,
            ACTIONS.UPDATE,
            setSnackbarInfo
        );
        if (res.status.code === 1) {
            await handleUpdateTable();
            setModalDetails((modalState) => !modalState);

        }

        setInRequest((inRequest) => !inRequest);
        setIsLoading((isLoading) => !isLoading);
    };

    useEffect(() => {
        handleGetData()
    }, [])


    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                id: "",
                tipoDeDocumentoCod: "",
                tipoDeDocumentoNombre: "",
                tipoDeDocumentoDescripcion: "",
                enviaMail: true,
                agrupa: false,
                agrupaCant: 0,
                prioridadFirma: "N",
                PHFirmante: true,
                PHTickets: true,
                version: ""
            }}
            validationSchema={Yup.object({
                // tipoDeDocumentoCod: Yup.string(FORM_ERROR_MESSAGES.text)
                //     .required(FORM_ERROR_MESSAGES.required)
                //     .max(20, "Máximo 20 caracteres"),
                tipoDeDocumentoNombre: Yup.string(FORM_ERROR_MESSAGES.text)
                    .required(FORM_ERROR_MESSAGES.required)
                    .max(45, "Máximo 45 caracteres"),
                tipoDeDocumentoDescripcion: Yup.string(FORM_ERROR_MESSAGES.text)
                    .required(FORM_ERROR_MESSAGES.required)
                    .max(150, "Máximo 150 caracteres"),
                agrupa: Yup.boolean(),
                agrupaCant: Yup.number()
                    .when('agrupa', {
                        is: true,
                        then: (schema) => schema
                            .required(FORM_ERROR_MESSAGES.required)
                            .min(2, "Debe ser mayor a 1"),
                        otherwise: (schema) => schema.nullable()
                    })
            })}
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            {isLoadingInfo ? <div style={{ margin: "24px" }}><CircularIndeterminate /></div> : <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <Box display={"flex"} flexDirection={"row"} alignItems={"flex-end"} gap={"20px"} justifyContent={"space-between"} width={"100%"}>
                        <Box flex={2}>
                            <FormikTextInput
                                fullWidth={true}
                                name="tipoDeDocumentoNombre"
                                labelText={"Nombre"}
                                autofocus={true}
                            />
                        </Box>
                        <Box flex={1}>
                            <FormikTextInput
                                disabled={false}
                                fullWidth={true}
                                name="tipoDeDocumentoCod"
                                labelText={"Código"}
                                onChange={(e) => {
                                    const filtered = e.target.value.replace(/[^a-zA-Z0-9._-]/g, "");
                                    formikRef.current.setFieldValue("tipoDeDocumentoCod", filtered);
                                }}
                            />
                        </Box>
                    </Box>
                    <FormikTextInput
                        fullWidth={true}
                        name="tipoDeDocumentoDescripcion"
                        labelText={"Descripción"}
                    />
                    <Box display={"flex"} flexDirection={"row"} alignItems={"flex-end"} gap={"20px"} marginTop={"20px"} justifyContent={"space-between"} width={"100%"}>
                        <Paper elevation={2} style={{ padding: "14px", height: "-webkit-fill-available", flex: "1", display: "flex", flexDirection: "column", gap: "8px" }}>
                            <span style={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: "bold", display: "flex", width: "100%" }}>Orden de firmas</span>
                            <FormikSelectInput name={"prioridadFirma"} disabled={tieneDocs}>
                                {
                                    prioridadList.map((prioridad) => (
                                        <option value={prioridad.value} key={prioridad.value}>{prioridad.label} </option>
                                    ))
                                }
                            </FormikSelectInput>
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "8px" }}>
                                <span style={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: "bold", display: "flex", width: "100%" }}>Enviar mail</span>
                                {/* Enviar mail se puede editar siempre, aunque el tipo ya tenga documentos (sbmTipoDeDocumentoTieneDocumentos). */}
                                <FormikYesOrNoInput name={"enviaMail"} />
                            </div>
                        </Paper>
                        <Paper elevation={2} style={{ padding: "14px", height: "-webkit-fill-available", flex: "1", display: "flex", flexDirection: "column", gap: "8px" }}>
                            <span style={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: "bold", display: "flex", width: "100%" }}>Firmas Digitales</span>
                            <span style={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: "bold", display: "flex", width: "100%" }}>Requiere Placeholders</span>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                <span>Firmas</span>
                                <FormikYesOrNoInput name={"PHFirmante"} disabled={tieneDocs} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                <span>Tickets</span>
                                <FormikYesOrNoInput name={"PHTickets"} disabled={tieneDocs} />
                            </div>
                        </Paper>
                        <Paper elevation={2} style={{ padding: "14px", height: "-webkit-fill-available", flex: "1" }}>
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                <span style={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: "bold", display: "flex", width: "100%" }}>Agrupar Documentos</span>
                                <FormikYesOrNoInput name={"agrupa"} onChange={() => {
                                    setDisabledGroup((prev) => !prev)
                                    if (formikRef?.current?.values.agrupa === true) {
                                        formikRef.current.setFieldValue("agrupaCant", 0)
                                    }
                                }} disabled={tieneDocs} />
                            </div>
                            <FormikTextInput
                                disabled={disabledGroup || tieneDocs}
                                fullWidth={true}
                                name="agrupaCant"
                                labelText={"Documentos por grupo"}
                            />
                        </Paper>
                    </Box>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Guardar" }}
                        hasConfirmationModal={true}
                        onCloseModal={handleUpdateTable}
                    />

                    {isLoading && <CircularIndeterminate />}
                </div>
            </Form>}
        </Formik>
    );
}
